/**
 * Enum for Phone Code values.
 * @readonly
 * @enum {string}
 */
export enum EPhoneCode {
  /** Guatemala's phone code. */
  GT = 502,

  /** Costa Rica's phone code. */
  CR = 506,

  /** Honduras's phone code. */
  HN = 504,

  /** Nicaragua's phone code. */
  NI = 505,

  /** Panama's phone code. */
  PA = 507,

  /** El Salvador's phone code. */
  SV = 503
}
